module.exports = __webpack_public_path__ + "static-m/img/1.e244f26e.png";